import { render, staticRenderFns } from "./BusinessSubmission.vue?vue&type=template&id=46990cdf&scoped=true&"
import script from "./BusinessSubmission.vue?vue&type=script&lang=js&"
export * from "./BusinessSubmission.vue?vue&type=script&lang=js&"
import style0 from "./BusinessSubmission.vue?vue&type=style&index=0&id=46990cdf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46990cdf",
  null
  
)

export default component.exports